
   document.addEventListener('DOMContentLoaded', function () {

     console.log('loaded');
   
   // Function to update the target div
        function updatePriceContainer(newValue) {
          console.log('yes update with' + newValue);
            const targetDiv = document.querySelector('.price-container-to-update');
            if (targetDiv) {
                targetDiv.innerHTML = newValue;
            }
        }

        // Select the node that will be observed for mutations
        const priceContainer = document.querySelector('.price-container.mobile-only');

        if (priceContainer) {
            // Create an observer instance linked to the callback function
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        // When the content changes, update the target div
                        updatePriceContainer(mutation.target.innerHTML);
                    }
                }
            });

            // Configuration of the observer
            const config = { childList: true, subtree: true };

            // Start observing the target node for configured mutations
            observer.observe(priceContainer, config);
        }
     
    });